/**
 * @function addOrReplaceQueryStringParameter
 * @memberof Promega.Util
 * @description Adds a new parameter and value to the query string in the given URL, or replaces the parameter if it already exists in the query string 
 * @param {String} url The URL to use
 * @param {String} parameterName The name of the parameter to add or replace
 * @param {String} parameterValue The value of the parameter to add or replace
 * @returns {String} The new URL, with the updated query string
 */
export default function addOrReplaceQueryStringParameter (url, parameterName, parameterValue) {
    let startLocation = url.toString(),
        hashIndex = startLocation.indexOf("#"),
        hashValue = "",
        finalLocation = null,
        extraQueryString = null;

    if (hashIndex > 0) {
        hashValue = startLocation.slice(hashIndex);
        startLocation = startLocation.substring(0, hashIndex);
    }
        
    /// Check to see if the parameter is already in the query string, either with a ? or a & before it
    let indexOfQueryStringParameter = startLocation.indexOf("?" + parameterName + "=");
    if ( indexOfQueryStringParameter <= 0 ) {
        indexOfQueryStringParameter = startLocation.indexOf("&" + parameterName + "=");
    }
    if ( indexOfQueryStringParameter >= 0 ) {
        /// Check to see if there's more AFTER the query string parameter
        let indexOfAmpersand = startLocation.indexOf("&", indexOfQueryStringParameter + 1);
            
        finalLocation = startLocation.substring(0, indexOfQueryStringParameter);
            
        /// If there's more (not just an &, but also more beyond that), hold onto it for after we add the current param
        if ( indexOfAmpersand >= 0 && startLocation.length > indexOfAmpersand + 1 ) {
            extraQueryString = startLocation.substring(indexOfAmpersand);
        }
    } else {
        finalLocation = startLocation;
    }
    /// If there's a query string already, add an ampersand. If not, add a question mark.
    if ( finalLocation.indexOf("?") >= 0 ) {
        finalLocation += "&";
    } else {
        finalLocation += "?";
    }
    /// Add the querystring param and value to the end
    finalLocation += parameterName + "=" + parameterValue;
        
    if ( extraQueryString !== null ) {
        finalLocation += extraQueryString;
    }

    if (hashValue.length > 0) finalLocation += hashValue;

    return finalLocation;
}
